<main class="dashboard" aria-labelledby="dashboard-title">
  <header class="dashboard__heading">
    <h1 id="dashboard-title">{{ "resource_admin_dashboard_title" | translate }}</h1>
    <p>{{ "resource_admin_dashboard_description" | translate }}</p>
  </header>

  <section class="dashboard__grid" [attr.aria-label]="'resource_admin_dashboard_services' | translate">
    <mat-card class="dashboard-card">
      <div class="dashboard-card__image dashboard-card__image--jobs">
        <div class="dashboard-card__content">
          <h2>{{ "resource_admin_dashboard_open_jobs" | translate }}</h2>
          <div class="dashboard-card__metrics">
            <span>{{ "resource_admin_dashboard_open_jobs_count" | translate: { count: dashboardCounts.openJobs } }}</span>
            <span>{{ "resource_admin_dashboard_pending_approval_jobs_count" | translate: { count: dashboardCounts.pendingApprovalJobs } }}</span>
          </div>
        </div>
      </div>
      <div class="dashboard-card__action">
        <button mat-stroked-button [matMenuTriggerFor]="jobsMenu" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_open_jobs" | translate }} <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #jobsMenu="matMenu">
          <button mat-menu-item (click)="openJobs()">{{ "resource_admin_dashboard_open_jobs" | translate }}</button>
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_pending_approval_jobs" | translate }}</button>
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_unallocated_jobs" | translate }}</button>
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_unallocated_ppm_jobs" | translate }}</button>
        </mat-menu>
      </div>
    </mat-card>

    <mat-card class="dashboard-card">
      <div class="dashboard-card__image dashboard-card__image--ppm">
        <div class="dashboard-card__content">
          <h2>{{ "resource_admin_dashboard_bulk_ppm_manager" | translate }}</h2>
          <div class="dashboard-card__metrics">
            <span>{{ "resource_admin_dashboard_open_ppms_count" | translate: { count: dashboardCounts.openPpms } }}</span>
          </div>
        </div>
      </div>
      <div class="dashboard-card__action">
        <button mat-stroked-button (click)="openWorkbench()" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_ppm_manager" | translate }} <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    </mat-card>

    <mat-card class="dashboard-card">
      <div class="dashboard-card__image dashboard-card__image--invoicing">
        <div class="dashboard-card__content">
          <h2>{{ "resource_admin_dashboard_invoicing" | translate }}</h2>
          <div class="dashboard-card__metrics">
            <span>{{ "resource_admin_dashboard_awaiting_invoice_count" | translate: { count: dashboardCounts.jobsAwaitingInvoice } }}</span>
            <span>{{ "resource_admin_dashboard_pending_invoice_count" | translate: { count: dashboardCounts.pendingInvoiceApproval } }}</span>
            <span>{{ "resource_admin_dashboard_recalled_count" | translate: { count: dashboardCounts.recalledInvoices } }}</span>
            <span>{{ "resource_admin_dashboard_rejected_count" | translate: { count: dashboardCounts.rejectedInvoices } }}</span>
          </div>
        </div>
      </div>
      <div class="dashboard-card__action">
        <button mat-stroked-button [matMenuTriggerFor]="invoicingMenu" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_invoicing" | translate }} <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #invoicingMenu="matMenu">
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_jobs_awaiting_invoice" | translate }}</button>
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_submitted_invoices" | translate }}</button>
        </mat-menu>
      </div>
    </mat-card>

    <mat-card class="dashboard-card">
      <div class="dashboard-card__image dashboard-card__image--upgrades">
        <h2>{{ "resource_admin_dashboard_upgrade_request_summary" | translate }}</h2>
      </div>
      <div class="dashboard-card__action">
        <button mat-stroked-button (click)="openWorkbench()" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_job_upgrades" | translate }} <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    </mat-card>

    <mat-card class="dashboard-card">
      <div class="dashboard-card__image dashboard-card__image--reporting">
        <h2>{{ "resource_admin_dashboard_reporting" | translate }}</h2>
      </div>
      <div class="dashboard-card__action">
        <button mat-stroked-button [matMenuTriggerFor]="reportsMenu" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_reports" | translate }} <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #reportsMenu="matMenu">
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_contractor_status_report" | translate }}</button>
          <button mat-menu-item (click)="openWorkbench()">{{ "resource_admin_dashboard_completed_forms" | translate }}</button>
        </mat-menu>
      </div>
    </mat-card>

    <mat-card class="dashboard-card">
      <div class="dashboard-card__image dashboard-card__image--safety">
        <h2>{{ "resource_admin_dashboard_health_safety" | translate }}</h2>
      </div>
      <div class="dashboard-card__action">
        <button mat-stroked-button (click)="openWorkbench()" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_document_library" | translate }} <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    </mat-card>

    <mat-card class="dashboard-card">
      <div class="dashboard-card__image dashboard-card__image--notifications">
        <h2>{{ "resource_admin_dashboard_notifications" | translate }}</h2>
      </div>
      <div class="dashboard-card__action">
        <button mat-stroked-button (click)="openWorkbench()" [disabled]="isRedirectingToWorkbench">
          {{ "resource_admin_dashboard_notifications" | translate }} <mat-icon>open_in_new</mat-icon>
        </button>
      </div>
    </mat-card>

    <mat-card class="dashboard-card">
      <div class="dashboard-card__image dashboard-card__image--guides">
        <h2>{{ "resource_admin_dashboard_reference_guides" | translate }}</h2>
      </div>
      <div class="dashboard-card__action">
        <button mat-stroked-button [matMenuTriggerFor]="guidesMenu">
          {{ "resource_admin_dashboard_portal_guides" | translate }} <mat-icon>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #guidesMenu="matMenu">
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-008-City-Workbench-User-Guide-Overview.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_portal_overview" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-010-City-Workbench-User-Guide-Completing-Job-Closedown.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_job_closedowns" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-011-City-Workbench-User-Guide-Completing-PPM-Forms.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_ppm_forms" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2026/08/PRO-UG-022-City-Workbench-User-Guide-Bulk-PPM-Manager.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_bulk_ppm_manager" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-012-City-Workbench-User-Guide-Submitting-Invoices.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_invoicing" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-009-City-Workbench-User-Guide-Completing-Job-Upgrades.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_job_upgrades" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-013-City-Workbench-User-Guide-Fast-Job-Update-Process.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_fast_job_updates" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2025/09/PRO-UG-014-City-Workbench-User-Guide-Creating-a-Subcontractor-Administrator-User-Profile.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_create_admin_profile" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2024/04/PRO-UG-016-City-Workbench-User-Guide-User-Management.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_user_management" | translate }}</a>
          <a mat-menu-item href="https://www.cityfm.com.au/wp-content/uploads/2024/04/PRO-UG-015-City-Workbench-User-Guide-Creating-a-Technician-User-Profile.pdf" target="_blank" rel="noopener noreferrer">{{ "resource_admin_dashboard_create_technician_profile" | translate }}</a>
        </mat-menu>
      </div>
    </mat-card>

    <mat-card class="dashboard-card">
      <div class="dashboard-card__image dashboard-card__image--users">
        <h2>{{ "resource_admin_dashboard_user_management" | translate }}</h2>
      </div>
      <div class="dashboard-card__action">
        <button mat-stroked-button (click)="openUserManagement()">
          {{ "resource_admin_dashboard_user_management" | translate }} <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </mat-card>
  </section>
</main>